<content>
    <section id="big-modal" >
    <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-2-modal'">
            <label>{{'mantenimientoMarcas.table.marca' | translate}} *</label>
            <input type="text" formControlName="nombre">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-2-modal'">
            <label>{{'mantenimientoMarcas.table.alias' | translate}}</label>
            <input type="text" formControlName="alias">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-2-modal'">
            <label>{{'mantenimientoMarcas.table.disenyoCaja' | translate}}</label>
            <app-filterable-list class="short-list" [itemsList]="disenyoCajas" [selectedItem]="newEditForm.get('etiquetaCaja')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-2-modal'">
            <label>{{'mantenimientoMarcas.table.disenyoPallet' | translate}}</label>
            <app-filterable-list class="short-list" [itemsList]="disenyoPallets" [selectedItem]="newEditForm.get('etiquetaPallet')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-2-modal'">
            <label>{{'mantenimientoMarcas.table.grupoCaja' | translate}}</label>
            <app-filterable-list class="shorter-list" [itemsList]="grupoCajas" [selectedItem]="newEditForm.get('grupoCajas')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-2-modal'">
            <label>{{'mantenimientoMarcas.table.grupoPallet' | translate}}</label>
            <app-filterable-list class="shorter-list" [itemsList]="grupoPallets" [selectedItem]="newEditForm.get('grupoPallets')" [placeHolder]="false"></app-filterable-list>
        </div>
    </form>
    </section>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{marcaId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>